import { createFileRoute } from '@tanstack/react-router'
import { createOrgShortcutComponent } from '~/pages/org-shortcuts'

export const Route = createFileRoute('/org/')({
  component: createOrgShortcutComponent('/org/$org')
})
